import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import Typography from '@components/v2/ui/Typography/Typography';
import { Box } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';

const MAX_LABEL_LENGTH = 20;
const DOT_SIZE = 8;

interface StatusBadgeProps {
  label: LangEnum;
  color: string;
}

function StatusBadge({ label, color }: StatusBadgeProps) {
  const { translate } = useTranslation();

  const fullLabel = translate(label);
  const isTruncated = fullLabel.length > MAX_LABEL_LENGTH;
  const displayLabel = isTruncated ? `${fullLabel.slice(0, MAX_LABEL_LENGTH)}…` : fullLabel;

  return (
    <Tooltip TooltipContent={isTruncated ? fullLabel : null}>
      <Box
        test-id="global-search-status-badge"
        sx={(theme) => ({
          display: 'inline-flex',
          alignItems: 'center',
          gap: 0.75,
          flexShrink: 0,
          maxWidth: '100%',
          px: 1,
          py: 0.25,
          borderRadius: `${theme.shape.borderRadiusFull}px`,
          backgroundColor: theme.palette.action.selected,
        })}
      >
        <Box
          sx={{
            flexShrink: 0,
            width: DOT_SIZE,
            height: DOT_SIZE,
            borderRadius: '50%',
            backgroundColor: color,
          }}
        />
        <Typography variant="body2" color="text.secondary" noWrap>
          {displayLabel}
        </Typography>
      </Box>
    </Tooltip>
  );
}

export default StatusBadge;
